<form [formGroup]="contactDataForm" *ngIf="connectionChangeConfig$ | async as config">
  <h2>Anschrift des Anschlussnehmers</h2>
  <app-contact-form
    [formGroup]="contactDataForm.controls.customer"
    [connectionObjectData]="connectionObjectData" />
  <ng-container *ngIf="config.differingInvoiceContactField !== FieldConfigEnum.HIDDEN">
    <h2>Rechnungsanschrift</h2>
    <form-row>
      <mat-checkbox [formControl]="contactDataForm.controls.differingInvoiceAddress">
        Abweichende Rechnungsanschrift
      </mat-checkbox>
    </form-row>
    <app-contact-form
      *ngIf="!!contactDataForm.controls.differingInvoiceAddress.value; else identicalAddress"
      [formGroup]="contactDataForm.controls.invoiceContact"
      [connectionObjectData]="connectionObjectData" />
    <ng-template #identicalAddress>
      <p>Rechnungsanschrift identisch mit Anschrift des Anschlussnehmers</p>
    </ng-template>
  </ng-container>
</form>
